export default "/assets/images/chart-01.svg?0b9dbafdf3176f811b857f474857cb61";